
// constant messages
export const configMsg = {
    invalidCard: 'Card is invalid',
    completeSale: 'complete_sale',
    goTopage: 'go_page'

};

